import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { api, errCode } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();
  const { t, lang } = useLang();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId, language: lang })
      .then(({ data }) => {
        login(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      })
      .catch((e) => {
        const code = errCode(e);
        setError(t(`errors.${code}`, code));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid min-h-screen place-items-center" data-testid="auth-callback">
      {error ? (
        <div className="panel p-6 text-sm text-[#ff9b9e]">{error}</div>
      ) : (
        <div className="flex items-center gap-3 text-sm text-vox-muted"><Loader2 className="animate-spin" size={16} />{t("common.loading")}</div>
      )}
    </div>
  );
}
